module.exports = __webpack_public_path__ + "d0fcb8cf5f9ccc6acd51e74fda6f6a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/logotypes/cultures.png
// module id = 678
// module chunks = 17